<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0" >
        <h1>{{ $STR.tituloCentroAyuda }} {{ sProducto }}</h1>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 nav-contenedor-primary">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <h5>
          <router-link :to="routeDashboard"
            >{{ $STR.navVistaPrincipal }}
          </router-link>
          > <b>{{ $STR.textResultadoBusqueda }}</b>
        </h5>
      </v-col>
    </v-row>
    <v-row v-if="sToken != ''" class="pa-4 ma-0 titulo-contenedor align-content-center flex-wrap d-flex" >
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0" >
        <v-btn color="primary" elevation="2" medium rounded x-large @click="onClickAgregarMaterial()">{{ $STR.btnAgregarMaterial }}</v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" lg="12" md="12" sm="12" class="pa-0 ma-0" >
        <v-text-field
          v-model="sBusqueda"
          :label="sTextoBusqueda"
          append-icon="fa-search"
          background-color="white"
          flat
          hide-details
          outlined
          rounded
          clearable
          dense
          @click:append="onLoadData"
          @keyup.enter="onLoadData"
          @click:clear="__clicClear"
        />
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <v-data-iterator :items="aPreguntasBusqueda" items-per-page.sync="5" hide-default-footer >
          <template v-slot:header>
            <v-row class="pa-4 ma-0">
              <v-col v-if="!cargando" lg="12" md="12" sm="12" class="pa-4 ma-0">
                <h3 v-if="aPreguntasBusqueda.length == 1">
                  {{ aPreguntasBusqueda.length }}
                  {{ $STR.textResultadoBusqueda }}
                </h3>
                <h3 v-else>
                  {{ aPreguntasBusqueda.length }}
                  {{ $STR.textResultadosBusqueda }}
                </h3>
              </v-col>
                <v-col v-else lg="12" md="12" sm="12" class="pa-4 ma-0">
                <h3 >
                  {{ $STR.textCargando }}
                </h3>
              </v-col>
            </v-row>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col class="pa-4 ma-0" v-for="item in props.items" :key="item.idBC_Preguntas" cols="12" sm="12" md="6" lg="4" > 
                <v-card @click="onCLickPregunta(item)" elevation="6" class="mx-auto" outlined >
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ item.Pregunta }} - {{ item.Tecnologia }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar>
                      <v-icon class="pa-4 ma-0" left>
                        mdi-chevron-right
                      </v-icon></v-list-item-avatar>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";
// import { mixFunciones } from "@/mixins/funciones.js";

export default {
  name: "modulo-modulo-ayuda",
  // mixins: [mixFunciones],
  components: {},
  mounted() {
    this.onLoadData();
  },
  data() {
    return {
      cargando: false,
      sToken: this.$store.state.token,
      sIP: sessionStorage.ip,
      sProducto: "",
      aPreguntasBusqueda: [],
      sLabelFiltro: this.$STR.phFiltroCategoria,
      aCategorias: [],
      aFiltro: [],
      sBusqueda: this.$route.query?.q || '',
      sTextoBusqueda: this.$STR.textCualPregunta,
    };
  },
  methods: {
    onLoadData() {      
      this.cargando = true;
      if (this.sBusqueda != "" && this.sBusqueda) {
        axiosServices.getConfiguration(`/base_conocimientos/preguntas/buscar/${this.sBusqueda}`, false, `app=${this.sApp}&token=${this.sToken}&tecnologia=${sessionStorage.tecnologia}&producto=${sessionStorage.producto}`)
          .then((aResponse) => {
            this.aPreguntasBusqueda = aResponse.aData;
            this.cargando = false;
          });
      }else{
        this.cargando = false;
        this.$swal.fire({
          title: 'Información',
          icon: 'info',
          text: 'Asegurese de completar el campo de busqueda'
        })
      }
    },
    onCLickPregunta(item) {
      sessionStorage.item = JSON.stringify(item);
      this.$router.push({
        path:
          "/Inicio/centro-de-ayuda/dashboard/producto/" +
          sessionStorage.producto +
          "/modulo/" +
          item.idBC_Modulos +
          "/pregunta/" +
          item.idBC_Preguntas,
      });
    },
    onClickAgregarMaterial() {
      this.$router.replace({ name: "NuevaPregunta" });
    },
    __clicClear() {
      this.sBusqueda = ''      
    }
  },
  computed: {
    routeDashboard() {
      const { producto, tecnologia, perfil, usuario, codigo } = sessionStorage;
      const url = `/Inicio/centro-de-ayuda/dashboard/producto/${producto}/?tecnologia=${tecnologia}&perfil=${perfil}&usuario=${usuario}&codigo=${codigo}`
      return url;
    }
  }
};
</script>
